import { useContext } from 'react';
import { TabsContext } from './TabsContext';

export function useTabsContext() {
    return useContext(TabsContext);
}
